module.exports = __webpack_public_path__ + "static/img/合规达标.676b2549.png";